// @flow
/* -----------------Types--------------- */
import type {
  Distribution,
  ProgressData,
  PerformanceWithProgress,
  EventContext,
  Image,
  LearningOrders,
  Score,
  UniqueAnswers,
  Content,
  SessionMeta,
} from '../types';
import type {
  AnsweredFacts,
} from '../session/types';

const flipEventType = {
  FLIP: 'FLIP',
  UNFLIP: 'UNFLIP',
  SKIP: 'SKIP',
  SHOW: 'SHOW',
  BACK: 'BACK',
  NEXT: 'NEXT',
  ANSWER: 'ANSWER',
  COMPLETE: 'COMPLETE',
  TERMINATE: 'TERMINATE',
};

/* -------------------Types for event mutations----------------------- */
type CardFront = {
  itemId: string,
  prompt?: ?string
}

type FlipItem = {
  cardBackIds: string[],
  cardFront: CardFront
}

type FlipPayload = {
  inReverseMode: boolean,
  flipItem: FlipItem
}

type FlipEventType = $Keys<typeof flipEventType>;

type FlipEvent = {
  eventContext: EventContext,
  eventType: FlipEventType,
  eventPayload: FlipPayload,
}

type AnswerPair = {
  termId: string,
  factId: string,
}

type CardState = {
  answerSeen: boolean,
  cardFlipped: boolean,
  confidenceProvided: boolean,
}
type CardBack = {
  distribution: Distribution<number>,
  factId: string,
  termId: string,
  name: string,
  prompt: string,
  images: Image[],
  currentScore: Score,
  previousScore: Score,
  score: number,
  timeFactor: number,
}
type FlipAnswer = {
  pairs: AnswerPair[],
  inReverseMode: boolean,
  confidence: number,
  cardStates: CardState[],
  itemId: string,
  cardBack: CardBack[],
  timeTaken: number,
  contentId: string
};

type FlashCard = {
  itemId: string,
  contentId: string,
  name: string,
  prompt?: ?string,
  images: Image[],
  cardBack: CardBack[],
}

type FlashCardCollection = {
  termCards: FlashCard[],
  factCards: FlashCard[],
}

type FlipState = {
  cardStates: CardState[],
  inReverseMode: boolean,
  currentIndex: number,
  answeredFacts: AnsweredFacts,
  distribution: Distribution<number>,
  events: FlipEvent[],
  answers: FlipAnswer[],
  uniqueAnswers: UniqueAnswers,
  progressData: ProgressData,
  lastSeenIndex: number,
  contextId: ?string,
  scheduleId: ?string,
  endTime: ?string,
  sessionId: ?string,
  startTime: ?string,
  flashCards: FlashCardCollection,
  sessionCreated: boolean,
  summary: ?PerformanceWithProgress,
  learningOrder: LearningOrders,
  requestedQuestionsCount: number,
  reviewedContents: Content[],
  hasMore: boolean,
  isSchedule: boolean,
  sessionMeta: SessionMeta,
  isLastCardVisible?: boolean
};

export {
  flipEventType,
};

export type {
  CardBack,
  Distribution,
  FlashCard,
  FlashCardCollection,
  FlipAnswer,
  FlipEvent,
  FlipEventType,
  FlipState,
  ProgressData,
  CardState,
};
